// import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import axios from "../../axiosInstance";

// const initialState = {
//   tickets: [],
//   ticketForm: {
//     subject: "",
//     description: "",
//   },
//   loading: false,
//   error: null,
// };

// // Async thunk for creating a support ticket
// export const createSupportTicket = createAsyncThunk(
//   "support/createSupportTicket",
//   async (ticketData, { rejectWithValue }) => {
//     try {
//       const response = await axios.post("/api/v1/support", ticketData);
//       return response.data.data; // Return the created ticket
//     } catch (error) {
//       return rejectWithValue(error.response?.data?.message || "Failed to create support ticket");
//     }
//   }
// );

// const supportSlice = createSlice({
//   name: "support",
//   initialState,
//   reducers: {
//     setTicketForm(state, action) {
//       state.ticketForm = { ...state.ticketForm, ...action.payload };
//     },
//     addTicket(state, action) {
//       state.tickets.push(action.payload);
//     },
//     resetForm(state) {
//       state.ticketForm = { subject: "", description: "" };
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(createSupportTicket.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(createSupportTicket.fulfilled, (state, action) => {
//         state.loading = false;
//         state.tickets.push(action.payload);
//         state.ticketForm = { subject: "", description: "" }; // Reset form on success
//       })
//       .addCase(createSupportTicket.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       });
//   },
// });

// export const { setTicketForm, addTicket, resetForm } = supportSlice.actions;
// export default supportSlice.reducer;

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../axiosInstance";

const initialState = {
  tickets: [],
  ticketForm: {
    subject: "",
    description: "",
  },
  loading: false,
  error: null,
};


// =====================================================
// CREATE SUPPORT
// =====================================================
export const createSupportTicket = createAsyncThunk(
  "support/createSupportTicket",
  async (ticketData, { rejectWithValue }) => {
    try {
      const response = await axios.post("/api/v1/support", ticketData);
      return response.data.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to create support ticket"
      );
    }
  }
);


// =====================================================
// GET ALL SUPPORT (ADMIN)
// =====================================================
export const getAllSupportTickets = createAsyncThunk(
  "support/getAllSupportTickets",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get("/api/v1/support");
      return response.data.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch support tickets"
      );
    }
  }
);


// =====================================================
// GET SUPPORT BY USER
// =====================================================
export const getMySupportTickets = createAsyncThunk(
  "support/getMySupportTickets",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get("/api/v1/support/user");
      return response.data.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch your tickets"
      );
    }
  }
);


// =====================================================
// DELETE SUPPORT (ADMIN)
// =====================================================
export const deleteSupportTicket = createAsyncThunk(
  "support/deleteSupportTicket",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.delete("/api/v1/support/delete", {
        data: { id },
      });
      return response.data.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to delete support ticket"
      );
    }
  }
);


// =====================================================
// SLICE
// =====================================================
const supportSlice = createSlice({
  name: "support",
  initialState,
  reducers: {
    setTicketForm(state, action) {
      state.ticketForm = { ...state.ticketForm, ...action.payload };
    },
    resetForm(state) {
      state.ticketForm = { subject: "", description: "" };
    },
  },
  extraReducers: (builder) => {
    builder

      // ================= CREATE =================
      .addCase(createSupportTicket.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createSupportTicket.fulfilled, (state, action) => {
        state.loading = false;
        state.tickets.unshift(action.payload);
        state.ticketForm = { subject: "", description: "" };
      })
      .addCase(createSupportTicket.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // ================= GET ALL =================
      .addCase(getAllSupportTickets.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllSupportTickets.fulfilled, (state, action) => {
        state.loading = false;
        state.tickets = action.payload;
      })
      .addCase(getAllSupportTickets.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // ================= GET MY =================
      .addCase(getMySupportTickets.pending, (state) => {
        state.loading = true;
      })
      .addCase(getMySupportTickets.fulfilled, (state, action) => {
        state.loading = false;
        state.tickets = action.payload;
      })
      .addCase(getMySupportTickets.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // ================= DELETE =================
      .addCase(deleteSupportTicket.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteSupportTicket.fulfilled, (state, action) => {
        state.loading = false;
        state.tickets = state.tickets.filter(
          (ticket) => ticket._id !== action.payload._id
        );
      })
      .addCase(deleteSupportTicket.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setTicketForm, resetForm } = supportSlice.actions;
export default supportSlice.reducer;
